// State wage-hour facts used ONLY for non-blocking warnings in People → Edit → Overtime
// (plan 088, Gitea #104). HourTrax computes overtime per workweek; nothing here changes pay.
// Copied from hr-reference/ (not shipped in the image, so not importable):
//   hr-reference/federal-exempt-thresholds.json  federal_salary_threshold, state_thresholds_above_federal
//   hr-reference/state-labor/index.json          states[].exempt_threshold_annual, states[].daily_overtime
//   hr-reference/state-labor/{WA,CA,NY,CO,ME,AK,NV}.json
// These figures and citations are NOT verified by counsel: confirm before relying on them. They are
// kept out of the end-user text on purpose (no unverified legal number in the UI). Salary floors
// change every January; update this file with the HR annual update (CLAUDE.md).
// TODO #128: AK exempt floor (AS 23.10.055(c)) and 2026-07-01 minimum wage — verify before adding

export const FEDERAL_EXEMPT_WEEKLY = 684;

// States whose exempt salary floor is above the federal $684/week. Where the floor has tiers,
// `weekly` is the higher one (more warnings, never fewer) and `note` names the other.
export const STATE_EXEMPT_SALARY = Object.freeze({
  WA: { name: 'Washington', weekly: 1541.70, note: 'employers with 51+ employees; a lower tier may apply to employers with 50 or fewer employees, so verify with L&I', cite: 'WAC 296-128-545' },
  CA: { name: 'California', weekly: 1352.00, note: 'twice the state minimum wage for full-time work', cite: 'Cal. Labor Code § 515(a)' },
  NY: { name: 'New York', weekly: 1275.00, note: 'NYC, Nassau, Suffolk and Westchester; $1,199.10/week elsewhere; executive and administrative exemptions', cite: '12 NYCRR § 142-2.14' },
  CO: { name: 'Colorado', weekly: 1111.23, note: '', cite: '7 CCR 1103-1, COMPS Order Rule 2.5.1' },
  ME: { name: 'Maine', weekly: 871.16, note: '', cite: '26 M.R.S. § 663(3)(K)' },
});

// States that owe overtime per workday, which HourTrax does not calculate.
export const STATE_DAILY_OVERTIME = Object.freeze({
  CA: { name: 'California', rule: '1.5× after 8 hours in a workday and 2× after 12, plus seventh-consecutive-day rules', cite: 'Cal. Labor Code § 510' },
  AK: { name: 'Alaska', rule: '1.5× after 8 hours in a workday (employers with 4 or more employees)', cite: 'AS 23.10.060' },
  NV: { name: 'Nevada', rule: '1.5× after 8 hours in a workday for employees paid less than 1.5× the state minimum wage, unless a 4×10 schedule was set by mutual agreement', cite: 'NRS 608.018' },
  CO: { name: 'Colorado', rule: '1.5× after 12 hours in a workday or 12 consecutive hours (not counting duty-free meal periods)', cite: '7 CCR 1103-1, COMPS Order Rule 4.1.1' },
});

// The state floor when it is above federal, else null (the federal $684 applies).
export const exemptSalaryFloor = (code) => {
  const s = code ? STATE_EXEMPT_SALARY[code] : null;
  return s && s.weekly > FEDERAL_EXEMPT_WEEKLY ? s : null;
};

export const dailyOvertimeRule = (code) => (code ? STATE_DAILY_OVERTIME[code] || null : null);
